import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { SortableContainer } from 'react-sortable-hoc';
import i18n from 'react-intl-universal';
import styles from './NotesWrapper.scss';

import { NOTES_NOT_FOUND } from '../../constants/variables';
import { Notebooks, Notes } from '../../constants/actionTypes';
import logEvents from '../../constants/logEvents';

import Icon from '../Icon/Icon';
import NoteList from '../NoteList/NoteList';
import withLoading from '../../HOC/withLoading';

import { setNoteData } from '../../actions/GlobalAction';
import { getNotes, newNote } from '../../actions/NotesAction';

import { getState } from '../../reducers/Notebooks/NotebooksReducer';
import { getState as getNotesState } from '../../reducers/Notes/NotesReducer';
import { getState as getUser } from '../../reducers/User/UserReducer';

import { getNormalPageUrl } from '../../utils/urlHelper.js';
import { martinDispatch } from '../../utils/util.js';
import formatDate from '../../utils/formatDate.js';
import logger from '../../utils/logger';

@SortableContainer
@withRouter
@connect(
  state => ({
    notebooks: getState(state),
    notes: getNotesState(state),
    notesStatus: getNotesState(state).get('status'),
    user: getUser(state),
  }),

  // atBottom（是否添加到底部）、hasTop（是否有置顶笔记）
  dispatch => ({
    setNoteData: data => dispatch(setNoteData(data)),
    getNotes: (nbId, isForce = false, page = 1, count = 10) => 
      dispatch(getNotes(nbId, isForce, page, count)),
    newNote: (nbId, title, atBottom, hasTop) =>
      martinDispatch(dispatch, newNote(nbId, title, atBottom, hasTop)),
  }),
)
@withLoading((props) => {
  const { notebooks, notesStatus, match } = props;
  const { params: { nbId } } = match;
  const notes = notebooks.getIn(['entities', nbId, 'notes'], NOTES_NOT_FOUND);
  // 如果已经获取到notebooks，且其长度为0，则移除loading
  const seq = notebooks.get('seq');
  const status = notebooks.get('status');
  // eslint-disable-next-line max-len
  if (seq && seq.size === 0 && status !== Notebooks.NOTEBOOKS_INIT && status !== Notebooks.GET_NOTEBOOKS) {
    return false;
  }
  if (notesStatus === Notes.GET_NOTES_FAIL) {
    return false;
  }
  return notes === NOTES_NOT_FOUND;
})({ tip: 'global.note-loading', wrapperClassName: styles['sort-wrapper'] })
export default class NotesWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCreatingNote: false,
      currentPage: 1,
      isLoadingMore: false,
      hasMore: true,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    const { params: { nbId } } = match;
    // 初始加载第一页数据由上层组件控制，这里只做检查
    // 简单延迟后检查是否有更多数据
    setTimeout(() => {
      this.checkHasMore();
    }, 2000);
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props;
    const { nbId } = match.params;
    const prevNbId = prevProps.match.params.nbId;
    
    // 如果切换了文集，则重新加载第一页
    if (nbId !== prevNbId) {
      this.setState({ 
        currentPage: 1,
        hasMore: true
      }, () => {
        // 文集切换时的数据加载由上层组件控制
        // 简单延迟后检查是否有更多数据
        setTimeout(() => {
          this.checkHasMore();
        }, 2000);
      });
    }
  }

  checkHasMore = () => {
    const { notebooks, match } = this.props;
    const { nbId } = match.params;
    const seq = notebooks.getIn(['entities', nbId, 'notes'], []);
    
    // 获取当前文集的文章总数
    const totalNotes = seq.size;
    const { currentPage } = this.state;
    
    // 判断是否还有更多数据（当前加载的文章数小于总文章数）
    // 或者当前页面加载的文章数等于每页数量（可能还有更多）
    this.setState({
      hasMore: (totalNotes % 10 === 0 && totalNotes > 0) || totalNotes >= currentPage * 10
    });
  };

  loadMoreNotes = () => {
    const { match } = this.props;
    const { nbId } = match.params;
    const { currentPage, isLoadingMore } = this.state;
    
    if (isLoadingMore) return;
    
    const nextPage = currentPage + 1;
    this.setState({ isLoadingMore: true });
    
    // 关键修改：使用true作为isForce参数，确保每次都发送请求
    this.props.getNotes(nbId, true, nextPage, 10);
    
    // 简单延迟后更新状态
    setTimeout(() => {
      this.setState({
        currentPage: nextPage,
        isLoadingMore: false,
      }, () => {
        this.checkHasMore();
      });
    }, 2000);
  };

  createNewNote = (atBottom = false) => {
    const { match, history, user, notebooks, notes } = this.props;
    const { params: { nbId } } = match;
    const { isCreatingNote } = this.state;
    if (isCreatingNote) {
      return;
    }
    this.setState({
      isCreatingNote: true,
    });
    const firstNote = notebooks.getIn(['entities', nbId, 'notes', 0]);
    const hasTop = firstNote ? notes.getIn(['entities', firstNote.toString(), 'is_top']) : false;
    this.props.newNote(nbId, formatDate(new Date(), 'yyyy-MM-dd'), atBottom, hasTop).then((res) => {
      // 创建文章成功后再打log
      logger.addLog({
        atBottom,
        event: logEvents.CREATE_NEW_NOTE,
        user_id: user.getIn(['user', 'id']),
        new_note_id: res.id,
      });
      // 跳转至新建文章, 通过isInitNote标识首次创建文章
      this.props.setNoteData({ isInit: true });
      if (+res.id !== +this.props.match.params.noteId) {
        history.push(getNormalPageUrl(nbId, res.id));
      }
      this.setState({
        isCreatingNote: false,
      });
    }).catch((error) => {
      this.setState({
        isCreatingNote: false,
      });
    });
  };

  onCreateNoteBtnClick = () => {
    this.createNewNote(false); // 改为 false，确保文章添加到顶部
  };

  createNewNoteAtBottom = () => {
    this.createNewNote(true); // 保持不变，底部添加文章
  };

  render() {
    const { isCreatingNote } = this.state;
    const { hasMore, isLoadingMore } = this.state;
    
    return (
      <div>
        <div className={styles['new-note-top']} onClick={this.onCreateNoteBtnClick}>
          <Icon name={'plus-circle'}/>
          <span> {i18n.get(isCreatingNote ? 'notes.new-note-ing' : 'notes.new-note')}</span>
        </div>
        <NoteList/>
        <div className={styles['new-note-bottom']} onClick={this.createNewNoteAtBottom}>
          <Icon name={'plus'}/>
          <span> {i18n.get(isCreatingNote ? 'notes.new-note-ing' : 'notes.new-note-bottom')}</span>
        </div>
        <div style={{ padding: '10px', textAlign: 'center' }}>
          {hasMore ? (
            <button 
              onClick={this.loadMoreNotes}
              disabled={isLoadingMore}
              style={{
                background: '#f0f0f0',
                border: '1px solid #ddd',
                borderRadius: '4px',
                padding: '6px 12px',
                cursor: isLoadingMore ? 'not-allowed' : 'pointer',
                color: isLoadingMore ? '#999' : '#333'
              }}
            >
              {isLoadingMore ? i18n.get('global.loading') : i18n.get('global.load-more')}
            </button>
          ) : (
            <div style={{ color: '#999', padding: '10px 0' }}>
              {i18n.get('global.no-more-notes')}
            </div>
          )}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/NotesWrapper/NotesWrapper.js